import React from "react";
import { Controller } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

const FormDatePicker = ({
  name,
  control,
  label,
  defaultValue,
  rules,
  helperText,
  disableFuture,
  handleOnChange,
  ...props
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || null}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          <DatePicker
            {...field}
            label={label}
            value={field.value ? dayjs(field.value) : null}
            onChange={(newValue) => {
              field.onChange(newValue ? dayjs(newValue) : null);
              if (handleOnChange) {
                handleOnChange(newValue);
              }
            }}
            disableFuture={disableFuture}
            slotProps={{
              textField: {
                helperText: error ? error.message : helperText,
                error: !!error,
                fullWidth: true
              }
            }}
            {...props}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default FormDatePicker;
